export abstract class DateTimeFormat {
    static LONG: string         = 'LLL';
    static MEDIUM: string       = 'lll';
    static SHORT: string        = 'l LT';
    static LONG_DATE: string    = 'LL';
    static MEDIUM_DATE: string  = 'll';
    static SHORT_DATE: string   = 'l';
    static LONG_TIME: string    = 'LTS';
    static SHORT_TIME: string   = 'LT';
}

export abstract class DefactoDateFormat {
    static MONTH_YEAR: string           = 'MMMM YYYY';
    static SHORT_MONTH_YEAR: string     = 'MMM YYYY';
    static SHORT_MONTH_DATE: string     = 'MMM DD';
    static SHORT_MONTH: string          = 'MMM';
    static DATE: string                 = 'DD';
    static YEAR: string                 = 'YYYY';
    static LONG_YEAR_MONTH_DATE: string = 'YYYY-MM-DD';
}
